// SS Script
const edMode = window.location.href.indexOf('ed=1') > -1;
const ENVkinetiq = window.location.href.indexOf('kinetiq.network') > -1;
const queryparams = (window.location.search !== "") ? window.location.search.substring(1).split("&") : "";
const ss = (function() {
    var ss_mobilemenu = function () {
        document.querySelector('.g-PrimaryMenu_HeaderLinks').classList.add('js-open');
        document.querySelector('.m-Menu_Mobile').classList.add('js-open');
    }
    
    var ss_nav = function (index) {
        var selectedNavItem = document.querySelectorAll('#block-nayzilam-main-menu ul.m-Menu > li')[parseInt(index)]; 

        if (selectedNavItem) {
            selectedNavItem.classList.add('menu-item--active-trail');

            var subnavstyles = { top:"85px", opacity: "1", left: "0"};
            var subnav = selectedNavItem.querySelector('ul.m-SubMenu');

            if (subnav) {
                Object.assign(subnav.style, subnavstyles);
            }
        }
    }

    var init = function (editorialMode, queryString) {
        // IF ENV is Kinetiq, update body CSS to hide errors
        if (ENVkinetiq) {
            document.body.classList.add("KQ");
        }

        // IF EDMode, all states to be triggered
        if (editorialMode === true) {
            document.body.classList.add("EDMode");
            
        } 

        
        if (queryString.indexOf('isi=1') > -1) { /* NO ADDITION ACTION, HANDLED BY isi.js */
            setTimeout(() => {
                document.querySelector('body').style.overflow = 'auto';
                //document.querySelector('.g-Isi_Snippet').style.top = '9.4%';
                if ( window.innerWidth < 600 ) {
                    document.querySelector('.g-Isi_Snippet').style.top = '690px';
                }
            }, 3000);
        }

        
        if (edMode === true && window.location.href.indexOf('/healthcare-professionals') > -1 && queryString.indexOf('isi=1') > -1) { /* NO ADDITION ACTION, HANDLED BY isi.js */
            setTimeout(() => {
                document.querySelector('body').style.overflow = 'auto';
                if ( window.innerWidth < 600 ) {
                    document.querySelector('.g-Isi_Snippet').style.top = '661px';
                }
                
            }, 3000);
        }

        if (queryString.indexOf('mobilemenu=1') > -1) {
            ss_mobilemenu();
            document.querySelector('nav#block-nayzilam-main-menu').style.maxHeight = 'none';
        }
        if (window.location.search.indexOf('nav=') > -1) {
            var navItem = queryString.filter(i => i.split('=')[0] === 'nav');
            console.log(queryString)
            
            if (navItem.length === 1 && navItem[0].split('=')[1] != "") {
                ss_nav(navItem[0].split('=')[1]);
            }
            if (queryString.indexOf('dropdown=1') > -1) {
                document.querySelector('.menu-item--active-trail ul > li').classList.add('active-m-link');
             
            }
        }
        if (queryString.indexOf('accordion=1') > -1) {
            document.querySelector('.c-SavingsCard_EligibilityToggle').classList.add('is-active');
        }
        
        if (queryString.indexOf('modal=trainingkit') > -1) {
            openModal('.g-Modal_TrainingKit');
            document.querySelector('.g-Modal_TrainingKit').style.top = '31.3%';
            document.querySelector('.g-Modal_TrainingKit').style.maxHeight = 'none';
            document.querySelector('.g-Modal_TrainingKit').style.position = 'absolute';
            document.querySelector('body').style.overflow = 'auto';
            setTimeout(() => {
                document.querySelector('.g-Isi_Snippet').style.top = '36%';
            }, 3000);
        }
        if (queryString.indexOf('modal=external') > -1) {
            openModal('.g-Modal_LeavingSite');
            document.querySelector('.g-Modal_LeavingSite').style.top = '31.3%';
            document.querySelector('.g-Modal_LeavingSite').style.position = 'absolute';
            
        }

        if (queryString.indexOf('modal=hcp') > -1) {
            openModal('.g-Modal_HCP');
            document.querySelector('.g-Modal_HCP').style.top = '31.3%';
        }

        if (queryString.indexOf('modal=hcptrainingkitvideo') > -1) {
            document.querySelector('.g-TrainingKitVideoTrigger').click();
            document.querySelector('.g-training-kit-video').style.top = '42%';
            document.querySelector('.g-training-kit-video').style.position = 'absolute';
            document.querySelector('body').style.overflow = 'auto';
            setTimeout(() => {
                //document.querySelector('.g-Isi_Snippet').style.top = '49%';
                document.querySelector('.g-Isi_Snippet').style.top = '44%';
            }, 3000);
        }

        if (queryString.indexOf('modal=hcptrainingkit') > -1) {
            document.querySelector('input#edit-hcp-declaration').click();
            openModal('.g-Modal_TrainingKit');
            document.querySelector('.g-Modal_TrainingKit').style.top = '65%';
            document.querySelector('.g-Modal_TrainingKit').style.maxHeight = 'none';
            document.querySelector('.g-Modal_TrainingKit').style.position = 'absolute';
            document.querySelector('body').style.overflow = 'auto';
            setTimeout(() => {
                //document.querySelector('.g-Isi_Snippet').style.top = '69.7%';
                document.querySelector('.g-Isi_Snippet').style.top = '70%';
            }, 3000);
        }
        
        if (queryString.indexOf('modal=trainingkitvideo') > -1) {
            document.querySelector('.g-TrainingKitVideoTrigger').click();
            document.querySelector('.g-training-kit-video').style.top = '32.5%';
            document.querySelector('.g-training-kit-video').style.position = 'absolute';
            document.querySelector('body').style.overflow = 'auto';
            setTimeout(() => {
                //document.querySelector('.g-Isi_Snippet').style.top = '38%';
                document.querySelector('.g-Isi_Snippet').style.top = '34.8%';
            }, 3000);
        }

        if (queryString.indexOf('modal=howtovideo') > -1) {
            document.querySelector('.g-HowToVideoTrigger').click();
            document.querySelector('.g-HowToVideo').style.top = '25%';
            document.querySelector('.g-HowToVideo').style.position = 'absolute';
            document.querySelector('body').style.overflow = 'auto';
            setTimeout(() => {
                //document.querySelector('.g-Isi_Snippet').style.top = '30%';
                document.querySelector('.g-Isi_Snippet').style.top = '27%';
            }, 3000);
        }
        
        if (queryString.indexOf('checkedForm=1') > -1) {
            document.querySelector('input#edit-sms-kit-sms-kit').click();
            document.querySelector('input#edit-direct-mail-options-welcome-kit').click()
          
        } 
        
        if (queryString.indexOf('eligibility=1') > -1) {
            document.querySelector('button.c-SavingsCard_EligibilityToggle').click();
        }

        if (queryString.indexOf('backtotop=1') > -1){
            document.querySelector('.g-backToTop').classList.add('ss-btT');;
        }


        
        return true;
    }
    
    // Initialization of SS functionality
    init(edMode, queryparams);
    
    return {
        init: init,
        edmode: edMode
    }
});

ss();
